export var PageLayout;
(function (PageLayout) {
  PageLayout["ONE_COLUMN"] = "one-column";
  PageLayout["TWO_COLUMN"] = "two-column";
})(PageLayout || (PageLayout = {}));